export enum NotificationType {
    Undefined = 0,
    Confirmation = 1,
    Checkin = 2,
    UpdateConfirmation = 3,
    Cancelled = 4
}
